import React from "react";

import {
  Card,
  SummaryButton,
  SummaryContainer,
  SummaryTitle,
} from "./index.styles";

const Summary = () => {
  return (
    <SummaryContainer>
      <SummaryTitle>
        <h2>Start a conversation with your next hire</h2>
        <p>
          Search millions of quality candidates and connect with responsive
          talent that you'll want to hire. Find a interesting candidate? Reach
          out and send a message directly from QuirkyCoders Resume
        </p>
      </SummaryTitle>
      <Card>
        <span className="fa fa-users" />
        <h3>Discover Great Talent</h3>
        <p>
          Search and view over 150 million resumes and access a growing talent
          pool with over 7 million new resumes added every month
        </p>
        <SummaryButton href="">Read more </SummaryButton>
      </Card>
      <Card>
        <span className="fa fa-search" />
        <h3>Speed up you search</h3>
        <p>
          Target your search by industry, education, title, location and more.
          Sign up for resume alerts and get new resumes delivered to you inbox.
        </p>
        <SummaryButton href="">Read more </SummaryButton>
      </Card>
      <Card>
        <span className="fa fa-check-circle" />
        <h3>Responsive Candidates</h3>
        <p>
          With over 7 million resumes updated every month and a 55% total
          response rate, QuirkyCoders Resume connects you with quality
          candidates ready for their next career move.
        </p>
        <SummaryButton href="">Read more </SummaryButton>
      </Card>
    </SummaryContainer>
  );
};

export default Summary;

